import * as fromPages from '../reducers/content-pages.reducer';
import * as fromNews from '../reducers/news.reducer';
import * as fromEvents from '../reducers/events.reducer';

import { ActionReducerMap, createFeatureSelector, MetaReducer } from '@ngrx/store';
import { environment } from '../../../../environments/environment';

export const featureKey = 'content';

export interface ContentState {
  contentPages: fromPages.ContentPagesState;
  news: fromNews.NewsState;
  events: fromEvents.EventsState;
}

export const reducers: ActionReducerMap<ContentState> = {
  contentPages: fromPages.contentPageReducer,
  news: fromNews.NewsReducer,
  events: fromEvents.EventsReducer,
};

export const getContentState = createFeatureSelector<ContentState>('content');

export const metaReducers: MetaReducer<ContentState>[] = !environment.production ? [] : [];
